import styled from 'styled-components'
import { breakpoints } from '../../../../constants'
import { MEDIUMORANGE } from '../../../../styles/colors.style'

export const Banner = styled.div`
	background: ${MEDIUMORANGE};
	margin-top: -24px;

	img {
		display: block;
		margin: 0 auto;
		width: 100%;
		max-height: 500px;
	}
	
	@media (min-width: ${breakpoints.MOBILE}px) {
		img {
			width: 100%;
			display: block;
			margin: 0 auto;
			max-width: 1200px;
			height: 424px;
		}
	}
`
